import type { TinyColor } from '@ctrl/tinycolor';
import type { BdColorFactory } from './color-factory';

export class BdColorHelper {
  /**
   * Calculates an array consisting of value/color pairs for use in mapbox-gl-js step expression.
   * For specification see: https://www.mapbox.com/mapbox-gl-js/style-spec#expressions-ramps-scales-curves
   */
  public static getColorStepExpression(
    minValue: number,
    maxValue: number,
    stepCount: number,
    colorFactory: BdColorFactory,
  ): (string | number)[] {
    const range = maxValue - minValue;
    const stepSize = Math.floor(range / stepCount);
    const expression: (string | number)[] = [];

    for (let i = 0; i < stepCount; i++) {
      const stepValue = minValue + stepSize * i;
      const color: TinyColor = colorFactory.getColorForValue(
        stepValue,
        minValue,
        maxValue,
      );

      expression.push(color.toHexString());

      if (i < stepCount - 1) {
        expression.push(stepValue);
      }
    }

    return expression;
  }
}
